/* eslint-disable react/no-array-index-key */
import React, { useState, useEffect } from 'react';
import { Box, Button, Grid, TextField, InputLabel, Select, MenuItem, Autocomplete } from '@mui/material';
import { useDispatch } from 'react-redux';
import useStyles from './styles';
import { createNewAsset } from '../../../store/admin/manual-onboarding/actions';
import { DeviceType } from '../../../entities/config-capabilities-v1';

type Type = {
    value: string;
    label: string;
}
const options = [
    { typeName: 'PL240' },
    { typeName: 'PL240B' },
    { typeName: 'PL240_ATT' },
    { typeName: 'PL240B_ATT' },
    // { typeName: 'PL042' },

    { typeName: 'PL243' },
    { typeName: 'PL083' },
    { typeName: 'PLCN1' },

    { typeName: 'PL131' },
    { typeName: 'PL141' },

    { typeName: 'PL161' },
    { typeName: 'PL161E' },
    { typeName: 'PL161SE' },
    { typeName: 'PL641' },
    { typeName: 'PL671' },
    { typeName: 'PL241' },
    { typeName: 'PL542' },
    { typeName: 'PL631' },
];

const listOfOptions = options.map((s) => ({
    value: `${s.typeName}`,
    label: `${s.typeName}`,
}));

const ManualOnboarding = () => {
    const [type, setType] = useState<string>('');
    const [typeList, setTypeList] = useState<Type[]>(listOfOptions);
    const [deviceId, setDeviceId] = useState<string>('');
    const [supplierSerialNumber, setSupplierSerialNumber] = useState<string>('');
    const [catSerialNumber, setCatSerialNumber] = useState<string>('');
    const [catPartNumber, setCatPartNumber] = useState<string>('');
    const [catFirmwarePartNumber, setCatFirmwarePartNumber] = useState<string>('');
    const [saveEnabled, setSaveEnabled] = useState<boolean>(false);

    const classes = useStyles();
    const dispatch = useDispatch();
    const boxProperties = {
        p: 3,
        className: classes.box,
    };

    const typeRegex = /[^\da-z]/i;
    const specialCharRegex = /[^\d-]/;
    const macRegex = /[^\d:a-z]/i;
    const numberRegex = /[^\d$+]/;

    const reset = () => {
        setCatFirmwarePartNumber('');
        setCatPartNumber('');
        setCatSerialNumber('');
        setDeviceId('');
        setSupplierSerialNumber('');
        setType('');
    }

    const createNewAssetInput = () => {
        const basicInput = {
            type,
            catFirmwarePartNumber,
            catPartNumber,
            catSerialNumber,
            supplierSerialNumber,
        };
        let input = {}
        switch (type) {
            case "PL243": {
                input = {
                    ...basicInput, deviceId,
                };
                break;
            }
            case "PL083": {
                input = {
                    ...basicInput, deviceId,
                };
                break;
            }
            case "PLCN1": {
                input = {
                    ...basicInput, deviceId,
                };
                break;
            }
            case "PL161": {
                input = {
                    ...basicInput, macAddress: deviceId,
                };
                break;
            }
            case "PL161E": {
                input = {
                    ...basicInput, macAddress: deviceId,
                };
                break;
            }
            case "PL161SE": {
                input = {
                    ...basicInput, macAddress: deviceId,
                };
                break;
            }
            case "PL641": {
                input = {
                    ...basicInput, macAddress: deviceId,
                };
                break;
            }
            case "PL671": {
                input = {
                    ...basicInput, macAddress: deviceId,
                };
                break;
            }

            case "PL241": {
                input = {
                    ...basicInput, macAddress: deviceId,
                };
                break;
            }


            case "PL542": {
                input = {
                    ...basicInput, macAddress: deviceId,
                };
                break;
            }
            case "PL631": {
                input = {
                    ...basicInput, macAddress: deviceId,
                };
                break;
            }
            case "PL131": {
                input = {
                    ...basicInput, imei: deviceId,
                };
                break;
            }
            case "PL141": {
                input = {
                    ...basicInput, imei: deviceId,
                };
                break;
            }

            case "G6:M7": {
                input = {
                    ...basicInput, certificate: deviceId,
                };
                break;
            }

            default: {
                input = {
                    ...basicInput, deviceId: undefined
                }
                break;
            }

        }
        dispatch(createNewAsset(input));
        reset();
    }
    const handelChange = (value: string) => {
        setType(value as string);
        setCatFirmwarePartNumber('');
        setCatPartNumber('');
        setCatSerialNumber('');
        setDeviceId('');
        setSupplierSerialNumber('');
    }
    const isSaveEnabled = () => {
        if ((type === 'PL240' || type === 'PL240B' || type === 'PL240_ATT' || type === 'PL240B_ATT') && catFirmwarePartNumber && catPartNumber && catSerialNumber && supplierSerialNumber
            && !specialCharRegex.test(catFirmwarePartNumber) && !specialCharRegex.test(catPartNumber)
            && !typeRegex.test(supplierSerialNumber) && !typeRegex.test(catSerialNumber)) {
            return true;
        }
        if (type !== 'PL240' && catFirmwarePartNumber && catPartNumber && catSerialNumber && supplierSerialNumber && deviceId
            && !specialCharRegex.test(catFirmwarePartNumber) && !specialCharRegex.test(catPartNumber)
            && !typeRegex.test(supplierSerialNumber) && !typeRegex.test(catSerialNumber) &&
            (!typeRegex.test(deviceId) || !numberRegex.test(deviceId) || !macRegex.test(deviceId))) {
            return true;
        }
        return false;
    }

    useEffect(() => {
        setSaveEnabled(isSaveEnabled());
    }, [type, catFirmwarePartNumber, catPartNumber, catSerialNumber, supplierSerialNumber, deviceId]);



    return (
        <Grid container direction="row" alignItems="stretch">
            <Grid item xs={12} md={6}>
                <Box {...boxProperties}>
                    <InputLabel>Device Type</InputLabel>
                    <Autocomplete
                        className={classes.select}
                        options={listOfOptions}
                        renderInput={(parameters) => <TextField variant="standard" {...parameters} />}
                        onChange={(event, newValue) => {
                            if (newValue) {
                                handelChange(newValue.value);
                            }
                        }}
                    />
                </Box>
            </Grid>
            {type !== '' && (
                <>
                    {type === 'PL243' || type === 'PL083' || type === 'PLCN1' ?
                        <Grid item xs={12} md={6}>
                            <Box {...boxProperties}>
                                <InputLabel>Device Id</InputLabel>
                                <TextField
                                    variant="standard"
                                    id="deviceId"
                                    className={classes.textfield}
                                    value={deviceId}
                                    onChange={(event) => setDeviceId(event.target.value as string)}
                                    error={typeRegex.test(deviceId)}
                                    helperText={typeRegex.test(deviceId) && 'Enter valid Device Id'}
                                />
                            </Box>
                        </Grid>
                        :
                        (type === 'PL131' || type === 'PL141') ?
                            <Grid item xs={12} md={6}>
                                <Box {...boxProperties}>
                                    <InputLabel>IMEI</InputLabel>
                                    <TextField
                                        variant="standard"
                                        id="imei"
                                        className={classes.textfield}
                                        value={deviceId}
                                        onChange={(event) => setDeviceId(event.target.value as string)}
                                        error={numberRegex.test(deviceId)}
                                        helperText={numberRegex.test(deviceId) && 'Enter valid IMEI'}
                                    />
                                </Box>
                            </Grid>
                            :
                            (type === 'PL161' ||
                                type === 'PL161E' ||
                                type === 'PL161SE' || type === 'PL641' ||
                                type === 'PL671' || type === 'PL241' || type === 'PL542' || type === 'PL631') ?
                                <Grid item xs={12} md={6}>
                                    <Box {...boxProperties}>
                                        <InputLabel>MAC Address</InputLabel>
                                        <TextField
                                            variant="standard"
                                            id="macAddress"
                                            className={classes.textfield}
                                            value={deviceId}
                                            onChange={(event) => setDeviceId(event.target.value as string)}
                                            error={macRegex.test(deviceId)}
                                            helperText={macRegex.test(deviceId) && 'Enter valid MAC Address'}
                                        />
                                    </Box>
                                </Grid>
                                : (type === 'G6:M7') ?
                                    <Grid item xs={12} md={6}>
                                        <Box {...boxProperties}>
                                            <InputLabel>Certificate</InputLabel>
                                            <TextField
                                                variant="standard"
                                                id="certificate"
                                                className={classes.textfield}
                                                value={deviceId}
                                                onChange={(event) => setDeviceId(event.target.value as string)}
                                                error={typeRegex.test(deviceId)}
                                                helperText={typeRegex.test(deviceId) && 'Enter valid Certificate'}
                                            />
                                        </Box>
                                    </Grid>
                                    : ''
                    }

                    <Grid item xs={12} md={6}>
                        <Box {...boxProperties}>
                            <InputLabel>Cat Serial Number</InputLabel>
                            <TextField
                                variant="standard"
                                id="catSerialNumber"
                                className={classes.textfield}
                                value={catSerialNumber}
                                onChange={(event) => setCatSerialNumber(event.target.value as string)}
                                error={typeRegex.test(catSerialNumber)}
                                helperText={typeRegex.test(catSerialNumber) && 'Enter valid Serial Number'}
                            />
                        </Box>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <Box {...boxProperties}>
                            <InputLabel>Supplier Serial Number</InputLabel>
                            <TextField
                                variant="standard"
                                id="supplierSerialNumber"
                                className={classes.textfield}
                                value={supplierSerialNumber}
                                onChange={(event) => setSupplierSerialNumber(event.target.value as string)}
                                error={typeRegex.test(supplierSerialNumber)}
                                helperText={typeRegex.test(supplierSerialNumber) && 'Enter valid Supplier Serial Number'}
                            />
                        </Box>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <Box {...boxProperties}>
                            <InputLabel>Part Number</InputLabel>
                            <TextField
                                variant="standard"
                                id="catPartNumber"
                                className={classes.textfield}
                                value={catPartNumber}
                                onChange={(event) => setCatPartNumber(event.target.value as string)}
                                error={specialCharRegex.test(catPartNumber)}
                                helperText={specialCharRegex.test(catPartNumber) && 'Enter valid Part Number'}
                            />
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Box {...boxProperties}>
                            <InputLabel>FirmWare Part Number</InputLabel>
                            <TextField
                                variant="standard"
                                id="catFirmwarePartNumber"
                                className={classes.textfield}
                                value={catFirmwarePartNumber}
                                onChange={(event) => setCatFirmwarePartNumber(event.target.value as string)}
                                error={specialCharRegex.test(catFirmwarePartNumber)}
                                helperText={specialCharRegex.test(catFirmwarePartNumber) && 'Enter valid Firmware Part Number'}
                            />
                        </Box>
                    </Grid>
                </>
            )}
            <Grid item xs={12} md={12}>
                <Box className={classes.flexBox}>
                    <Button
                        disabled={!saveEnabled}
                        className={classes.button}
                        variant="outlined"
                        onClick={() => {
                            createNewAssetInput();
                        }}
                    >
                        Create
                    </Button>
                </Box>
            </Grid>
        </Grid>
    );
};

export default ManualOnboarding;



